import { currencyFormatter } from '../utils/currencyFormatter.js';
import { eventBucketConfig } from '../helper/EventBucketConfig.js';
/**
 * Set up and render the Donate options, handle order inline donation.
 *
 * @return {Object|null} {donateSelectHtml, donateAmountHtml, donateTotal} - Object containing user details like name and email if the user is logged in.
 */
export function donateInlineOrderPrompt() {
  const globalEventConfig = eventBucketConfig.get();
  if (!globalEventConfig || Object.keys(globalEventConfig).length === 0) {
    return null;
  }

  const donateInlineOrderPrompt = globalEventConfig?.donate_inline_order_prompt ?? false;

  if (!donateInlineOrderPrompt) {
    return null;
  }

  let donateOptions = '';
  globalEventConfig?.donate_inline_levels && globalEventConfig.donate_inline_levels.forEach(option => {
    donateOptions += `<button class="donate-option" data-donate-amount="${option.amount}" type="button"><span>${currencyFormatter(option.amount / 100, 'EUR', 'de-DE', 0)}</span></button>`;
  });

  return {
    donateFirstCell: `
      <td class="item--info first-cell">
        <div>
          ${globalEventConfig?.donate_inline_order_title ? `<div>${globalEventConfig.donate_inline_order_title}</div>` : 'Donation'}
        </div>
      </td>
    `,
    donateSelectHtml: `
      <td id="gd__checkout__inline__donate" colspan="2">
        <button class="donate-option" data-donate-amount="0" type="button"><span>0 €</span></button>
        ${donateOptions}
        <button class="donate-option other" data-donate-amount="0" type="button"><span>other</span></button>
      </td> 
    `,
    donateTotal: 0,
  };
}

/**
 * Handles the donation logic when a button is clicked or custom donation is entered.
 * @param {HTMLElement} container - The container where donation buttons exist.
 * @param {function} onDonationChange - Callback when donation changes.
 */
export function handleDonationSelection(container, onDonationChange) {
  // Listen for clicks on donation buttons
  container.addEventListener('click', (event) => {
    if (event.target.classList.contains('donate-option')) {
      const selectedAmount = parseInt(event.target.getAttribute('data-donate-amount'), 10);
      onDonationChange(selectedAmount);
    }
  });

  // Handle custom donation input
  const customDonationInput = container.querySelector('#custom-donation');
  if (customDonationInput) {
    customDonationInput.addEventListener('input', () => {
      const customAmount = parseFloat(customDonationInput.value.replace('€', '').replace(',', '.')) * 100;
      if (!isNaN(customAmount) && customAmount > 0) {
        onDonationChange(customAmount);
      }
    });
  }
}
